import { LitElement, css, html, unsafeCSS } from "lit";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import styl from "./PageLayout.css?raw";
export class RdPageLayout extends LitElement {
  static properties = {
    showTop: { type: Boolean, reflect: true },
    showLeft: { type: Boolean, reflect: true },
    showRight: { type: Boolean, reflect: true },
    showBottom: { type: Boolean, reflect: true },
    showCenter: { type: Boolean, reflect: true },

    topHeight: { type: String, reflect: true },
    bottomHeight: { type: String, reflect: true },
    leftWidth: { type: String, reflect: true },
    rightWidth: { type: String, reflect: true },

    rightFullHeight: { type: Boolean, reflect: true },
    leftFullHeight: { type: Boolean, reflect: true },
  };

  static styles = css`
    ${unsafeCSS(styl)}
  `;

  updated(changedProperties) {
    super.updated(changedProperties);

    // Apply grid template directly when dimensions change
    const layout = this.shadowRoot.querySelector(".page-layout");
    if (!layout) return;

    // Helper function to check if size should be auto
    const isAuto = (size) => !size || size === "auto";

    // Build grid-template-columns
    const leftWidth = isAuto(this.leftWidth) ? "auto" : this.leftWidth;
    const rightWidth = isAuto(this.rightWidth) ? "auto" : this.rightWidth;
    const showLeft = this.hasAttribute("showLeft");
    const showRight = this.hasAttribute("showRight");

    let columns;
    if (!showLeft && !showRight) {
      columns = "1fr";
    } else if (!showLeft) {
      columns = `0 1fr ${rightWidth}`;
    } else if (!showRight) {
      columns = `${leftWidth} 1fr 0`;
    } else {
      columns = `${leftWidth} 1fr ${rightWidth}`;
    }

    // Build grid-template-rows
    const topHeight = isAuto(this.topHeight) ? "auto" : this.topHeight;
    const bottomHeight = isAuto(this.bottomHeight) ? "auto" : this.bottomHeight;
    const showTop = this.hasAttribute("showTop");
    const showBottom = this.hasAttribute("showBottom");

    let rows;
    if (!showTop && !showBottom) {
      rows = "1fr";
    } else if (!showTop) {
      rows = `0 1fr ${bottomHeight}`;
    } else if (!showBottom) {
      rows = `${topHeight} 1fr 0`;
    } else {
      rows = `${topHeight} 1fr ${bottomHeight}`;
    }

    layout.style.gridTemplateColumns = columns;
    layout.style.gridTemplateRows = rows;
  }

  render() {
    return html`
      <div class="page-layout">
        <div class="top-section">
          <slot name="top"></slot>
        </div>
        <div class="left-section">
          <slot name="left"></slot>
        </div>
        <div class="center-section">
          <slot name="center"></slot>
        </div>
        <div class="right-section">
          <slot name="right"></slot>
        </div>
        <div class="bottom-section">
          <slot name="bottom"></slot>
        </div>
      </div>
    `;
  }
}
if (!customElements.get("rd-page-layout")) customElements.define("rd-page-layout", RdPageLayout);
